import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { ChecklistItems } from '../../../api/configurations/checklist/types';
import { AuthenticationTabs, SocialNetworksForm, SocialsList } from '../../../components';
import { HeaderTitle, Preloader, Separator, ToNavigationError } from '../../../components/ui';
import { useChecklist, useCurrentProject, useSocialConnections } from '../../../contexts/settings';
import { RouteParams } from '../../../routes/types';
import { haveSocialsConnect } from '../../../utils';

const SocialConnection = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { enableChecklistItem } = useChecklist(projectId);

  const intl = useIntl();
  const { currentProjectFetching, error: projectError } = useCurrentProject(projectId);
  const {
    currentSocials,
    currentSocialsFetching,
    setCurrentSocials,
    error: socialError
  } = useSocialConnections(projectId);

  useEffect(() => {
    if (haveSocialsConnect(currentSocials)) {
      enableChecklistItem(ChecklistItems.CONNECTED_SOCIAL);
    }
  }, [currentSocials]);

  if (currentProjectFetching || currentSocialsFetching) {
    return (
      <AuthenticationTabs>
        <Preloader />
      </AuthenticationTabs>
    );
  }

  if (projectError || socialError) {
    return (
      <ToNavigationError error={projectError || socialError} pageName="social-connection_open" />
    );
  }

  return (
    <AuthenticationTabs>
      <HeaderTitle
        title={intl.formatMessage({ id: 'social-connection.title' })}
        subtitle={intl.formatMessage({ id: 'social-connection.subtitle' })}
      />
      <SocialsList
        projectId={projectId}
        currentSocials={currentSocials}
        currentSocialsFetching={currentSocialsFetching}
        setCurrentSocials={setCurrentSocials}
      />
      <Separator />
      <SocialNetworksForm projectId={projectId} />
    </AuthenticationTabs>
  );
};

export default withRouter(SocialConnection);
